import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CreativePreviewModal } from '@features/campaigns/builder/components/FormFields/common/CreativePreviewModal/CreativePreviewModal';
import { FileItemTemplate } from '@features/campaigns/builder/components/FormFields/common/FileUpload/components/FileItemTemplate/FileItemTemplate.tsx';
import { CREATIVE_CATEGORY, CREATIVE_TYPE } from '@features/campaigns/builder/types/creativeType.ts';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface SwitchInCreativePreviewProps {
  leftCreativeUrl?: string | null;
  bottomCreativeUrl?: string | null;
  fileName: string;
  headerText: string;
}

export function SwitchInCreativePreview({
  leftCreativeUrl,
  bottomCreativeUrl,
  fileName,
  headerText,
}: SwitchInCreativePreviewProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
  const fallbackCreativeUrl = leftCreativeUrl || bottomCreativeUrl || '';

  const handleToggleModalVisibility = () => setIsPreviewModalVisible(!isPreviewModalVisible);

  return (
    <>
      <FileItemTemplate
        fileName={t(fileName)}
        fileURL={fallbackCreativeUrl}
        fileFormatSize={''}
        creativeCategory={CREATIVE_CATEGORY.IMAGE}
        togglePreviewModal={handleToggleModalVisibility}
        canDeleteFile={false}
        switchInThumbnail={{
          leftImageUrl: leftCreativeUrl ?? undefined,
          bottomImageUrl: bottomCreativeUrl ?? undefined,
        }}
      />
      <CreativePreviewModal
        isModalVisible={isPreviewModalVisible}
        toggleModalVisibility={handleToggleModalVisibility}
        creativeType={CREATIVE_TYPE.SWITCH_IN}
        headerText={headerText}
        switchInAssets={{
          leftCreativeUrl: leftCreativeUrl ?? undefined,
          bottomCreativeUrl: bottomCreativeUrl ?? undefined,
        }}
        isLeftPreviewEditable={false}
        isBottomPreviewEditable={false}
      />
    </>
  );
}
